import React from 'react';
import { Link } from 'gatsby';
import { Container, StLogo } from './Header.css';
import { LaboratorioDeContenidosDeMarca, LaterceraWhite } from 'copesa-logos';
import Nav from './Nav';

const Header = ({ sponsorLogo }) => (
	<Container>
		<div className="col col1">
			<Link to="/" className="slotSite">
				<StLogo>
					<LaterceraWhite />
				</StLogo>
			</Link>
		</div>
		<div className="col col2">
			<a className="btn-suscribete" href="https://especiales.latercera.com/suscripcion/?utm_medium=interactivo&utm_source=ninosabc1&" target="_blank" rel="noopener noreferrer">Suscríbete</a>
			<Nav />
		</div>
	</Container>
);

export default Header;
